export default __webpack_public_path__ + "static/media/Clasp of the Amaranthine Drums.c14f0c82.jpg";